import type { ApiRunningProcess } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type RunningProcessStartedEvent = AvvirEvent<typeof RUNNING_PROCESS_STARTED, { runningProcess: ApiRunningProcess }>

const runningProcessStarted = (runningProcess: ApiRunningProcess): RunningProcessStartedEvent => ({
  type: RUNNING_PROCESS_STARTED,
  payload: { runningProcess },
});

export const RUNNING_PROCESS_STARTED = "running_process_started";

export default runningProcessStarted;
